import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { IMG_URL } from "../../api/imgApi/ImgApi";
import { useRequest } from "../../hooks/useRequest/useRequest";
import { REQUEST_STATUS } from "../../hooks/useRequest/useRequest.constants";
import "./galery.css";

const Galery = () => {
  const lang = localStorage.getItem("i18nextLng");
  const [galery, setGalery] = useState<any>([]);

  const [galeryClient, galeryData, galeryStatus] = useRequest();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    autoplaySpeed: 100,
    pauseOnHover: false,
    cssEase: "linear",
    rtl: false,
    responsive: [
      {
        breakpoint: 1084,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const settings2 = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    autoplaySpeed: 100,
    pauseOnHover: false,
    cssEase: "linear",
    rtl: true,
    responsive: [
      {
        breakpoint: 1084,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const { t } = useTranslation();

  useEffect(() => {
    galeryClient.get("product/images");
  }, []);

  const getGalery = () => {
    galeryData?.data?.map((item: any) => {
      if (galery.length === 0)
        return setGalery((prev: any) => [...prev, ...item.image]);
    });
  };

  useEffect(() => {
    if (galeryStatus === REQUEST_STATUS.success) {
      getGalery();
    }
  }, [galeryStatus]);

  return (
    <div className="my_galery" id="galery">
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="top-bottom"
        data-aos-duration="700"
      >
        <div className="my_galery_header">
          <h2 className={lang === "ru" ? "title active" : "title"}>
            {t("GALLERY.TITLEONE")}
          </h2>
          <div className={lang === "ru" ? "title_next active" : "title_next"}>
            {t("GALLERY.TITLETWO")}
          </div>
        </div>
      </div>

      <div className="galery_content">
        <div className="galery_first_row">
          <Slider {...settings} className="my_first_slide">
            {galery.length > 15 &&
              galery
                .slice(0, (galery.length / 2).toFixed())
                ?.map((item: any, index: any) => (
                  <div className="img_box" key={index}>
                    <img src={IMG_URL + item.url} alt="galery" />
                  </div>
                ))}
          </Slider>
        </div>

        <div className="galery_second_row">
          <Slider {...settings2} className="my_second_slide">
            {galery.length > 15 &&
              galery
                ?.slice((galery.length / 2).toFixed())
                ?.map((item: any, index: any) => (
                  <div className="img_box" key={index}>
                    <img src={IMG_URL + item.url} alt="galery" />
                  </div>
                ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Galery;
